import React, { createContext } from 'react';
export const FrodorModulesContext = createContext({
    onLinkClick: () => { },
    isFrodor: false,
});
export const FrodorModulesProvider = ({ children, onLinkClick, isFrodor = false, }) => {
    return (React.createElement(FrodorModulesContext.Provider, { value: { onLinkClick, isFrodor } }, children));
};
//# sourceMappingURL=FrodorModulesProvider.js.map